<template>
<!--手机号绑定-->
  <div id="mobilebind">
    <h2 class="title">
      <a href="" class="prev"></a>
      手机号绑定
    </h2>
    <div class="bind">
      <dl class="user">
        <dt>购买账户：</dt>
        <dd>
          <input type="text" value="Gabriel" disabled>
        </dd>
      </dl>
      <dl class="tel">
        <dt>手机号码：</dt>
        <dd>
          <input type="text" value="18298550030" required="" maxlength="11" pattern="^(1[3-9]d{9})$">
          <button>获取验证码</button>
        </dd>
      </dl>
      <dl class="verifycode">
        <dt>验证码：</dt>
        <dd>
          <input type="text" placeholder="请输入验证码" required="" maxlength="6">
        </dd>
      </dl>
      <dl class="submit">
        <dt></dt>
        <dd>
          <input type="submit" value="确定" class="active" disabled>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileBind'
}
</script>

<style scoped lang="stylus">
  #mobilebind
    .title
      position: relative
      height: 1.08rem
      line-height: .8rem
      background-color: transparent
      padding: .14rem .16rem
      font-size: .32rem
      color: #050505
      font-weight: 600
      text-align: center
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      a.prev
        position: absolute
        top: .14rem
        left: .16rem
        display: block
        width: .8rem
        height: .8rem
        background-color: #fff
        -webkit-border-radius: 50%
        -moz-border-radius: 50%
        border-radius: 50%
        &::before
          content: ""
          position: absolute
          top: .3rem
          left: .32rem
          display: block
          width: .20rem
          height: .20rem
          border-left: .03rem solid #050505
          border-bottom: .03rem solid #050505
          -webkit-transform: rotate(45deg)
          -moz-transform: rotate(45deg)
          -ms-transform: rotate(45deg)
          -o-transform: rotate(45deg)
          transform: rotate(45deg)
    .bind
      padding: 0 .4rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      dl
        dt
          margin-top: .54rem
          font-size: .3rem
          color: #3F3F3F
        dd
          position: relative
          height: .8rem
          line-height: .8rem
          border-bottom: .02rem solid #D9D9D9
          margin-top: .1rem
          input
            height: .6rem
            font-size: .4rem
          input:disabled
            background-color: transparent
            color: #BABABA
          button
            position: absolute
            top: .05rem
            right: 0
            display: inline-block
            width: 1.9rem
            height: .6rem
            line-height: .54rem
            background-color: transparent
            border: .02rem solid #999
            font-size: .28rem
            color: #666
            text-align: center
            -webkit-border-radius: .3rem
            -moz-border-radius: .3rem
            border-radius: .3rem
        &.verifycode
          dd
            border: none
            margin-top: .3rem
            input
              width: 6.7rem
              height: .96rem
              border: .02rem solid #D9D9D9
              padding: 0 .36rem
              font-size: .28rem
              -webkit-border-radius: .48rem
              -moz-border-radius: .48rem
              border-radius: .48rem
              -webkit-box-sizing: border-box
              -moz-box-sizing: border-box
              box-sizing: border-box
              &::-webkit-input-placeholder
                color: #BABABA
        &.submit
          margin-top: .78rem
          input[type=submit]
            display: block
            width: 6.7rem
            height: .96rem
            line-height: .96rem
            background-color: #1E81F2
            color: #fff
            font-size: .32rem
            text-align: center
            -webkit-border-radius: .48rem
            -moz-border-radius: .48rem
            border-radius: .48rem
            &:disabled
              background-color: #C5DEFC
</style>



// WEBPACK FOOTER //
// src/components/login/MobileBind.vue